// Generated by ReScript, PLEASE EDIT WITH CARE


function getRnrHome(param) {
  return {
          pointsSectionTitle: "మొత్తం రివార్డ్ పాయింట్లు",
          pointsSectionSubtitle: "కొత్త లెవెల్స్ చేరుకోండి మరియు అద్భుతమైన బహుమతులు గెలుచుకోండి",
          dailyRewardsHeader: "రోజువారీ బహుమతులు",
          cardCtaText: "దావా చేయడానికి నొక్కండి",
          allRewardsClaimedTitle: "అభినందనలు",
          allRewardsClaimedText: "మీరు అన్ని బహుమతులను పేర్కొన్నారు",
          noRewardsClaimedTitle: "మీకు ఇప్పుడు బహుమతులు లేవు",
          noRewardsClaimedText: "రేపు మళ్ళీ చూడండి",
          rewardHistoryFooterText: "రివార్డ్ మరియు బహుమతుల చరిత్ర",
          headerText: "పోర్టర్ రివార్డ్స్ కార్యక్రమం"
        };
}

function getMilestoneDetails(vehicleModel) {
  return {
          headerTitle: "గెలవండి " + vehicleModel,
          headerDetails: "అత్యధిక బహుమతి పాయింట్లు కలిగిన భాగస్వామి ఈ కొత్త ట్రక్ను గెలుచుకుంటాడు!",
          claimedText: "రివార్డ్ పొందారు",
          toClaimText: "మీ బహుమతిని క్లెయిమ్ చేయండి",
          footerText: "ముందు ముందు ఎక్కువ లెవెల్స్ అన్లాక్ అవుతాయి",
          milestone1: "స్టార్",
          milestone2: "బ్రోన్జ్ హీరో",
          milestone3: "బ్రోన్జ్ సూపర్ స్టార్",
          milestone4: "సిల్వర్ హీరో",
          milestone5: "సిల్వర్ సూపర్ స్టార్",
          milestone6: "ప్లాటినం హీరో",
          milestone7: "ప్లాటినం సూపర్ స్టార్",
          milestone8: "గోల్డ్ హీరో",
          milestone9: "గోల్డ్ సూపర్ స్టార్",
          milestone10: "డైమండ్ హీరో",
          milestone11: "డైమండ్ సూపర్ స్టార్",
          milestone12: "పోర్టర్ హీరో",
          milestone13: "సూఫ్రో సూపర్ స్టార్",
          locked: "లాక్"
        };
}

function getRnrCycleEnd(param) {
  return {
          greetings: " అభినందనలు ",
          winLabel: " మీరు గెలిచారు ఒక ",
          winNotice: " బహుమతిని ఎలా తీసుకోవాలో మేము మీకు కాల్ చేసి తెలియజేస్తాము ",
          lossNotice: " క్షమించాలి. మీరు ఈసారి ఏ బహుమతిని గెలుచుకోలేదు. బహుమతి గెలవడానికి దయచేసి తదుపరి సైకిల్(ప్రోగ్రామ్) లో బాగా పాల్గొనండి. ",
          endTitle: " పోర్టర్ రివార్డ్ ప్రోగ్రాం ముగిసింది. ",
          endText: " తదుపరి సైకిల్(ప్రోగ్రాం) అతి త్వరలో ప్రకటించబడుతుంది. ",
          scoreTitle: " మీరు ఎలా పెర్ఫర్మ్ చేసారో ఇక్కడ ఉంది ",
          totalScoreSubtext: " మొత్తం పాయింట్లు సేకరించబడ్డాయి ",
          customerExperienceScoreSubtext: " కస్టమర్ అనుభవాల కోసం ",
          orderCompletionScoreSubtext: " ఆర్డర్ పూర్తి కోసం ",
          loginActivityScoreSubtext: " లాగిన్ ఆక్టివిటీ కోసం ",
          topGiftsTitle: " కొన్ని టాప్ రివార్డ్స్ ఇక్కడ ఉన్నాయి ",
          topPartnersTitle: " ఇక్కడ కొంతమంది టాప్ పార్టనర్స్ ఉన్నారు ",
          partnerName: " పార్టనర్ పేరు ",
          awardTitle: " అవార్డు గెలిచారు "
        };
}

function getContent(param) {
  return {
          rnrHome: getRnrHome(undefined),
          rnrHistory: {
            title: "బహుమతులు",
            yesterdayRowTitle: "నిన్న",
            rewardNavTabTitle: "రోజువారీ బహుమతులు",
            awardNavTabTitle: "లెవెల్ బహుమతులు"
          },
          milestoneDetails: getMilestoneDetails("Mahindra"),
          customerServiceRewards: {
            text1: "మీరు సంపాదించారు",
            text2: "మంచి కస్టమర్ అనుభవం కోసం"
          },
          loginActivtyRewards: {
            text1: "మీరు సంపాదించారు",
            text2: "లాగిన్ ఆక్టివిటీ"
          },
          orderFulfillmentRewards: {
            text1: "మీరు సంపాదించారు",
            text2: "అంగీకరించిన అన్ని ఆర్డర్లు పూర్తి చేసినందుకు"
          },
          mahindraAwards: {
            cardTitle: "ఒక మహీంద్రా గెలవండి",
            cardText: "",
            modalTitle: "ఒక మహీంద్రా గెలవండి",
            modalText: "ప్రతి నెల ఆసక్తికరమైన బహుమతులు గెలుచుకోండి మరియు గ్రాండ్ బహుమతి మహీంద్రా సుప్రో. మరింత తెలుసుకోవడానికి మీ పాయింట్లను తనిఖీ చేస్తూ ఉండండి."
          },
          defaultLCVAward: {
            modalTitle: "ఈ దీపావళికి బంపర్ బహుమతులు మరియు ఇతర ఉత్తేజకరమైన బహుమతులను గెలుచుకునే అవకాశాన్ని పొందండి",
            modalText: ""
          },
          defaultHCVAward: {
            modalTitle: "ఈ దీపావళికి బంపర్ బహుమతులు మరియు ఇతర ఉత్తేజకరమైన బహుమతులను గెలుచుకునే అవకాశాన్ని పొందండి",
            modalText: ""
          },
          default2WAward: {
            modalTitle: "ప్రతి వారం ఉత్తేజకరమైన బహుమతులు గెలుచుకోండి.",
            modalText: ""
          },
          noAward: {
            cardTitle: "బహుమతిని పొందడానికి తదుపరి మైలురాయిని వేగంగా చేరుకోండి!",
            cardText: "మీరు గెలుచుకున్న బహుమతులను ఇతర భాగస్వాములు పొందారు.",
            modalTitle: "బహుమతి పొందడానికి తదుపరి మైలురాయిని వేగంగా చేరుకోండి!",
            modalText: "మీరు గెలుచుకున్న బహుమతులను ఇతర భాగస్వాములు పొందారు.మీరు బహుమతిని పొందటానికి దయచేసి తదుపరి మైలురాయిని చేరుకోండి"
          },
          insuranceAward: {
            cardTitle: "మీరు వాహన బీమాపై తగ్గింపును పొందారు",
            modalTitle: "హుర్రే! మీరు వాహన బీమాపై తగ్గింపును పొందారు"
          },
          distributionCeremonyAward: {
            cardTitle: "పోర్టర్ నుండి ఆకర్షణీయమైన బహుమతులు గెలుచుకునే అవకాశం మీకు ఉంది",
            cardText: "అత్యుత్తమ పనితీరు కనబరిచిన పార్టనర్స్ ఆకర్షణీయమైన బహుమతులు గెలుచుకునే అవకాశం ఉంది. షరతులు వర్తిస్తాయి",
            modalTitle: "పోర్టర్ నుండి ఆకర్షణీయమైన బహుమతులు గెలుచుకునే అవకాశం మీకు ఉంది",
            modalText: "అత్యుత్తమ పనితీరు కనబరిచిన పార్టనర్స్ ఆకర్షణీయమైన బహుమతులు గెలుచుకునే అవకాశం ఉంది. షరతులు వర్తిస్తాయి"
          },
          finalAward: {
            cardTitle: "పోర్టర్ నుండి \"మహీంద్రా సుప్రో\" వాహనాన్ని గెలుచుకునే అవకాశం మీకు ఉంది",
            cardText: "భారతదేశం అంతటా అత్యుత్తమ పనితీరు కనబరిచే పార్టనర్ గెలుస్తారు",
            modalTitle: "పోర్టర్ నుండి \"మహీంద్రా సుప్రో\" వాహనాన్ని గెలుచుకునే అవకాశం మీకు ఉంది",
            modalText: "భారతదేశం అంతటా అత్యుత్తమ పనితీరు కనబరిచే పార్టనర్ గెలుస్తారు. కార్యక్రమం ముగింపులో విజేతను ప్రకటిస్తారు. శరతలు మరియు అభ్యర్థనలు వర్తిస్తాయి"
          },
          couponAward: {
            couponText: "కూపన్",
            redeemTitle: "రేడీమ్ చేసుకునే విధానం",
            detailsText: "వివరాలు",
            tncText: "నిబంధనలు మరియు షరతులు",
            codeAckTitle: "కూపన్ కోడ్ కాపీ చేయబడింది"
          },
          status: {
            loading: "లోడింగ్",
            internetNotConnected: "ఇంటర్నెట్ కనెక్ట్ కాలేదు",
            tapToRetry: "మరోసారి ప్రయత్నిచేందుకు క్లిక్ చేయండి",
            ise: "ఏదో తప్పు జరిగింది",
            loadingFailed: "లోడింగ్ విఫలమైంది"
          },
          category: {
            customerService: "కస్టమర్ సర్వీస్",
            loginHours: "లాగిన్ ఆక్టివిటీ",
            orderFulfillment: "కంప్లీటెడ్ ఆర్డర్లు"
          },
          customerServiceDetails: {
            details1: "మీ ఆర్డరుకి కస్టమర్ 5 స్టార్ రేటింగ్స్ ఇవ్వడం వలన మీ కస్టమర్ సర్వీస్ పాయింట్స్ పెరుగుతాయి",
            details2: "కాబట్టి, మీరు చేసే 5 స్టార్ రేటింగ్ ఆర్డర్ల సంఖ్యను పెంచండి.",
            sectionHeader: "5 స్టార్ రేటింగ్స్ ఎలా పొందాలి ?",
            tip1: "ఎల్లప్పుడూ కస్టమర్లుతో గౌరవం మరియు మర్యాదపూర్వకంగా ఉండండి.",
            tip2: "కస్టమర్లతో ఎప్పుడూ వాదించవద్దు. వివాదాల సందర్భంలో కాల్ సెంటర్ నుండి సహాయం పొందండి",
            tip3: "కస్టమర్ వస్తువులను జాగ్రత్తగా చూసుకోండి."
          },
          loginHourDetails: {
            details1: "మీరు మరింత సమయం ఆన్లైన్లో ఉంటె మీకు ఎక్కువ లాగిన్ ఆక్టివిటీ పాయింట్స్ పొందుతారు",
            tips: "చిట్కాలు",
            tip: "ఎక్కువ సంపాదించడానికి మీ ఖాళీ సమయాన్ని ఆన్లైన్లో ఉండడానికి వినియోగించండి"
          },
          orderFulfillmentDetails: {
            details1: "కంప్లీటెడ్ ఆర్డర్లు పాయింట్లు  ఎలా సంపాదించాలి?",
            details2: " మీరు పూర్తి చేయాలనుకుంటున్న ఆర్డర్‌లను మాత్రమే అంగీకరించండి ",
            tip1: "అంగీకరించిన తర్వాత ఏ ఆర్డర్‌ను కాన్సెల్ చేయవద్దు",
            tip2: "ఆర్డర్‌ కాన్సెల్ చేయమని కస్టమర్ని ఎప్పుడూ అడగవద్దు ",
            slabTableText: "క్రింద టేబుల్ లో ప్రతి కంప్లీటెడ్ ఆర్డర్కు పాయింట్లు చుడండి",
            slabTableCol1: "కంప్లీటెడ్ ఆర్డర్లు",
            slabTableCol2: "పాయింట్లు"
          },
          miscellaneous: {
            points: "పాయింట్లు"
          },
          rnrCycleEnd: getRnrCycleEnd(undefined),
          getExpiryDateTitle: (function (date) {
              return "" + date + " కు గడువు ముగుస్తుంది";
            }),
          getExpiringDateTitle: (function (date) {
              return "" + date + " న ముగుస్తోంది";
            }),
          getExpiryHoursTitle: (function (hours) {
              return "" + hours + " గంటలలో గడువు ముగుస్తుంది";
            }),
          getCurrentMilestoneText: (function (currentMilestone) {
              return "మీరు ఒక " + currentMilestone;
            }),
          getNextMilestoneText: (function (points, nextMilestone) {
              return "" + nextMilestone + " గా మారడానికి " + points + " కావాలి";
            }),
          getCustomerServiceRewardsText: (function (qualifiedOrders) {
              return " " + qualifiedOrders + " ఫైవ్ స్టార్ ట్రిప్స్  ";
            }),
          getOrderFulfillmentRewardsText: (function (completedOrders, _requiredOrders) {
              return " మీరు " + completedOrders + " ఆర్డర్లు పూర్తి చేసారు";
            }),
          getLoginActivtyRewardsText: (function (loginHours) {
              return "బహుమాన లాగిన్ గంటలు " + loginHours;
            }),
          getLoginRewardsDetailsText: (function (points) {
              return "మీకు " + points + " లాగిన్ ఆక్టివిటీ పాయింట్లు ఉన్నాయి";
            }),
          getCustomerServiceRewardsDetailsText: (function (points) {
              return "మీకు " + points + " కస్టమర్ సర్వీస్ పాయింట్లు ఉన్నాయి";
            }),
          getNextMilestoneSubText: (function (points) {
              return "" + points + " పాయింట్లు దూరంగా";
            }),
          getCustomerServicePer5StarOrderPoints: (function (points) {
              return " ಪప్రతి 5 స్టార్ ఆర్డర్‌కు మీరు " + points + " పాయింట్లు పొందుతారు ";
            }),
          getLoginHourRewardsDetailsText: (function (startTime, endTime) {
              return " మీరు " + startTime + " నుండి " + endTime + " మధ్య పోర్టర్ అప్ప్ లో  ఆన్ లైన్ ఉంటే  మీ లాగిన్ ఆక్టివిటీ పాయింట్లు పెరుగుతాయి ";
            }),
          getLoginHourRewardsLoginWindowTip: (function (startTime, endTime) {
              return "" + startTime + " నుండి " + endTime + "  మధ్యలో మరింత ఆన్లైన్ పెట్టడానికి ప్రయత్నించండి";
            }),
          getLoginHourRewardsPerHourPointsTip: (function (points) {
              return " లాగిన్ చేసిన  ప్రతి గంటకు " + points + " పాయింట్లు. ఎక్కువ సమయం వలన ఎక్కువ పాయింట్లు పొందుతారు. ";
            }),
          getOrderFullfillmentRewardsDetailsText: (function (points) {
              return "మీకు " + points + " కంప్లీటెడ్ ఆర్డర్లు పాయింట్లు ఉన్నాయి";
            }),
          getOrderFullfillmentDailyMaxPointsTip: (function (points) {
              return "మీరు రోజుకు " + points + " పాయింట్లు మాత్రమే సంపాదించవచ్చు";
            }),
          getMilestonePointsRemaining: (function (points) {
              return " ఇంకా " + points + " పాయింట్లు అవసరం ";
            }),
          getLastSlabText: (function (orders) {
              return " " + orders + " లేదా అంతకంటే ఎక్కువ";
            }),
          getFuelAwardCardTitle: (function (fuelQuantity) {
              return " మీరు " + fuelQuantity + " లీటర్ల ఇంధనాన్ని గెలుచుకున్నారు ";
            }),
          getFuelAwardCardText: (function (fuelMoney) {
              return " మీ వాలెట్‌లో INR " + fuelMoney + " జమ అవుతుంది ";
            }),
          getFuelAwardModalTitle: (function (fuelQuantity) {
              return " హుర్రే! మీరు " + fuelQuantity + " లీటర్ల ఇంధనాన్ని గెలుచుకున్నారు ";
            }),
          getFuelAwardModalText: (function (fuelMoney) {
              return " మీ వాలెట్‌లో దానికి సమానమైన INR " + fuelMoney + " జమ చేయబడింది. ";
            }),
          getPremiumnessAwardCardTitle: (function (acceptAdvantage) {
              return " ఆర్డర్‌ల సమయంలో " + acceptAdvantage + " సెకన్ల ఆలస్యం లేదు! ";
            }),
          getPremiumnessAwardCardText: (function (acceptAdvantage, endDate) {
              return " ముగింపు తేదీ " + endDate + " వరకు మీరు ఆర్డర్‌ల సమయంలో " + acceptAdvantage + " సెకన్ల ఆలస్యాన్ని ఎదుర్కోరు ";
            }),
          getPremiumnessAwardModalTitle: (function (acceptAdvantage) {
              return " హుర్రే !! ఆర్డర్‌ల సమయంలో " + acceptAdvantage + " సెకన్ల ఆలస్యం లేదు! ";
            }),
          getPremiumnessAwardModalText: (function (acceptAdvantage, startDate, endDate) {
              return " మీరు పోర్టర్ ప్రీమియం భాగస్వామి అవార్డును గెలుచుకున్నారు. దిగువ పేర్కొన్న తేదీలలో మీరు ఇకపై ఆర్డర్‌లలో " + acceptAdvantage + " సెకన్ల ఆలస్యాన్ని ఎదుర్కోరు.\n        ప్రారంభ తేదీ - " + startDate + "\n        ముగింపు తేదీ - " + endDate + " ";
            }),
          getMonetaryAwardCardTitle: (function (amount) {
              return " మీరు ₹ " + amount + " గెలిచారు  ";
            }),
          getMonetaryAwardCardText: (function (amount) {
              return " మీరు గెలుచుకున్న ₹ " + amount + " బహుమతి వాలెట్‌లో జమ చేయబడింది. ";
            }),
          getMonetaryAwardModalTitle: (function (amount) {
              return " హుర్రే !! మీరు ₹ " + amount + " గెలిచారు. ";
            }),
          getMonetaryAwardModalText: (function (amount) {
              return " మీరు గెలుచుకున్న ₹ " + amount + " బహుమతి వాలెట్‌లో జమ చేయబడింది. ";
            }),
          getInsuranceAwardCardText: (function (price, endDate) {
              return " మీరు పోర్టర్ నుండి కేవలం ₹" + price + " కే బీమాను సేకరించవచ్చు. " + endDate + " వరకు చెల్లుతుంది ";
            }),
          getInsuranceAwardModalText: (function (price, endDate) {
              return " మీరు పోర్టర్ నుండి కేవలం ₹" + price + " కే బీమాను సేకరించవచ్చు. " + endDate + " వరకు చెల్లుతుంది ";
            }),
          getInsuranceAwardCardDiscountText: (function (discount, endDate) {
              return " మీరు పోర్టర్ నుండి మీ వాహన ఇన్సురెన్సు పై ₹ " + discount + " డిస్కౌంట్ గెలుచుకున్నారు !! " + endDate + " వరకు చెల్లుతుంది ";
            }),
          getInsuranceAwardModalDiscountText: (function (discount, endDate) {
              return " మీరు పోర్టర్ నుండి మీ వాహన ఇన్సురెన్సు పై ₹ " + discount + " డిస్కౌంట్ గెలుచుకున్నారు !! " + endDate + " వరకు చెల్లుతుంది ";
            }),
          getRewardMultiplierAwardCardTitle: (function (multiplier) {
              return " మీరు " + multiplier + " రివార్డ్ పాయింట్లను గెలుస్తారు ";
            }),
          getRewardMultiplierAwardCardText: (function (multiplier, startDate, endDate) {
              return " మీరు " + startDate + " నుండి ప్రతి క్యాటగిరీలో " + multiplier + " రివార్డ్ పాయింట్లను అందుకుంటారు. " + endDate + " వరకు చెల్లుతుంది ";
            }),
          getRewardMultiplierAwardModalTitle: (function (multiplier) {
              return " హుర్రే! మీరు " + multiplier + " రివార్డ్ పాయింట్లను గెలుస్తారు";
            }),
          getRewardMultiplierAwardModalText: (function (multiplier, startDate, endDate) {
              return " మీరు " + startDate + " నుండి ప్రతి క్యాటగిరీలో " + multiplier + " రివార్డ్ పాయింట్లను అందుకుంటారు. " + endDate + " వరకు చెల్లుతుంది ";
            }),
          getTopGiftCardSubtext: (function (recipient_cnt) {
              return " " + recipient_cnt + " భాగస్వాములకు ప్రదానం చేసాము ";
            })
        };
}

var Telugu = {
  getContent: getContent
};

export {
  Telugu ,
  
}
/* No side effect */
